import red from '@material-ui/core/colors/red';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#4285F4',
      contrastText: "white"
    },
    secondary: {
      main: '#00c853',
      contrastText: "white"
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    
  },
});

export default theme;
